import { getViewerIdAndKind, useSession } from '../../../../../infra/session';
import { useApiQuery } from '../../../../../infra/api';
import { endpoints as servicesEndpoints } from '../../../../services/network';
import { endpoints as campaignEndpoints } from '../../../network';
import { getEngageTableData } from './utils';
import { buildStatusFilterArray } from '../filters/filter-utils';
export var useTableData = function (_a) {
    var pagination = _a.pagination, filterState = _a.filterState, sortState = _a.sortState;
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var params = {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        status: buildStatusFilterArray(filterState.statusFilter),
        type: filterState.typeFilter,
        search: filterState.searchFilter || undefined,
        sortBy: sortState.sortValue,
        creatorIds: filterState.creatorFilter.length > 0 ? filterState.creatorFilter : undefined,
    };
    var campaignsQuery = useApiQuery({
        endpoint: campaignEndpoints.campaignsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            perPage: params.pageSize,
            page: params.page,
            type: params.type,
            status: params.status,
            sortBy: params.sortBy,
            search: params.search,
            creatorIds: params.creatorIds,
        },
        options: {
            enabled: !!viewerIdAndKind,
            keepPreviousData: true,
        },
    });
    var servicesQuery = useApiQuery({
        endpoint: servicesEndpoints.servicesQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            allAtOnce: true,
            apiVersion: 'v1',
        },
        options: {
            enabled: !!viewerIdAndKind,
        },
    });
    var customerGroupsQuery = useApiQuery({
        endpoint: campaignEndpoints.customerGroupsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
        },
        options: {
            enabled: !!viewerIdAndKind,
        },
    });
    var campaigns = campaignsQuery.data, isLoadingCampaigns = campaignsQuery.isLoading;
    var services = servicesQuery.data, isLoadingServices = servicesQuery.isLoading;
    var customerGroups = customerGroupsQuery.data, isLoadingCustomerGroups = customerGroupsQuery.isLoading;
    var isLoading = isLoadingCampaigns || isLoadingServices || isLoadingCustomerGroups;
    var tableData = isLoading ? [] : getEngageTableData((campaigns === null || campaigns === void 0 ? void 0 : campaigns.list) || [], services, customerGroups);
    return {
        tableData: tableData,
        isLoadingTableData: isLoading,
        count: (campaigns === null || campaigns === void 0 ? void 0 : campaigns.pagination.count) || 0,
        totalPages: (campaigns === null || campaigns === void 0 ? void 0 : campaigns.pagination.totalPages) || 0,
    };
};
